import { useSelector } from 'react-redux';
import { selectConnectedCrmOrgs } from '../environmentsReducer';
import { CrmOrg } from '../../../../types/CrmOrgs';

export const useAllowDelete = ({ allowDeleteLastEnv }: { allowDeleteLastEnv: boolean }) => {
  const environments = useSelector(selectConnectedCrmOrgs);
  const [prodEnvs, sandboxEnvs] = environments
    .filter((env) => env.isConnected)
    .reduce(
      (acc, curr) => {
        curr.isMain ? acc[0].push(curr) : acc[1].push(curr);
        return acc;
      },
      [[] as CrmOrg[], [] as CrmOrg[]],
    );
  const prodEnv = prodEnvs.length ? prodEnvs[0] : undefined;
  sandboxEnvs.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
  const allowDelete = allowDeleteLastEnv || prodEnvs.length + sandboxEnvs.length > 1;

  return { allowDelete, prodEnv, sandboxEnvs, environments };
};
